"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const icons_1 = require("@ant-design/icons");
const antd_1 = require("antd");
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const detectDevice_1 = __importDefault(require("../../../utils/detectDevice"));
const Form_1 = __importDefault(require("./components/form/Form"));
require("./LandingStyles.scss");
const constants_1 = require("../../../assets/constants/constants");
const LandingForm = (0, react_1.forwardRef)(({ scrollToRef }, ref) => {
    const { isMobile } = (0, detectDevice_1.default)(900);
    return (react_1.default.createElement("div", { className: "LandingForm", ref: ref },
        react_1.default.createElement(Form_1.default, null),
        !isMobile && (react_1.default.createElement("div", { className: "right-content" },
            react_1.default.createElement("div", { className: "top-content" },
                react_1.default.createElement("div", { className: "left-top" },
                    react_1.default.createElement(react_router_dom_1.Link, { to: "/" }, "Portal 360 Su\u00EDtes"),
                    react_1.default.createElement(antd_1.Typography.Link, { onClick: () => scrollToRef('about') }, "Como funciona"),
                    react_1.default.createElement(antd_1.Typography.Link, { onClick: () => scrollToRef('advantages') }, "Vantagens")),
                react_1.default.createElement("div", { className: "right-top" },
                    react_1.default.createElement("span", null, "Dados cadastrais"),
                    react_1.default.createElement("span", null, constants_1.OWNER_INFORMATIONS.address),
                    react_1.default.createElement("span", null, ` ${constants_1.OWNER_INFORMATIONS.city}, ${constants_1.OWNER_INFORMATIONS.state}`),
                    react_1.default.createElement("span", null, `CEP: ${constants_1.OWNER_INFORMATIONS.CEP}`))),
            react_1.default.createElement("div", { className: "bottom-content" },
                react_1.default.createElement("div", { className: "left-bottom" },
                    react_1.default.createElement("span", { className: "contact-us" }, "Fale conosco"),
                    react_1.default.createElement("span", null,
                        react_1.default.createElement(icons_1.MailOutlined, null),
                        constants_1.OWNER_INFORMATIONS.email),
                    react_1.default.createElement("span", null,
                        react_1.default.createElement(icons_1.WhatsAppOutlined, null),
                        ` ${constants_1.OWNER_INFORMATIONS.cell}`),
                    react_1.default.createElement("span", null,
                        react_1.default.createElement(icons_1.PhoneFilled, { twoToneColor: "#fff" }),
                        ` ${constants_1.OWNER_INFORMATIONS.telephone}`)),
                react_1.default.createElement("div", { className: "right-bottom" },
                    react_1.default.createElement("span", null, "Redes Sociais"),
                    react_1.default.createElement("a", { target: "_blank", rel: "noopener noreferrer", href: "https://www.linkedin.com/company/360suites" }, "Linkedin"),
                    react_1.default.createElement("a", { target: "_blank", rel: "noopener noreferrer", href: "https://www.facebook.com/360suites/" }, "Facebook"),
                    react_1.default.createElement("a", { target: "_blank", rel: "noopener noreferrer", href: "https://www.instagram.com/360suites/" }, "Instagram")))))));
});
exports.default = LandingForm;
